import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
import "./styles/current/index-home-public-badge-20260815m.css";
import "./styles/current/theme-green-verified-all-orange-20260811w.css";
import "./styles/current/front-login-pc-20260820.css";
import "./styles/current/user-name-white-20260828a.css";
import "./styles/current/edit-public-redblack-visible-20260905a.css";
import "./styles/current/detail-background-20260905a.css";
import "./styles/current/front-login-reference-layout-20260907.css";
import "./styles/current/hydsaf-timed-publish-20260910a.css";
import "./styles/current/platform-notice-20260910c.css";
createApp(App).use(router).mount("#app");
